import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { IBaselineCoverageRow } from './bieforecasting.models';

type Props = { rows: IBaselineCoverageRow[] };

class BaselineIntegrityCards extends React.PureComponent<Props> {
  renderMetric(label: string, value: any, tone?: 'success' | 'warning' | 'error' | 'info') {
    return (
      <Grid size={{ xs: 6, sm: 4, md: 2 }} key={label}>
        <Card elevation={1}>
          <CardContent>
            <Typography variant="caption" color="text.secondary">{label}</Typography>
            <Typography variant="h6" sx={{ fontWeight: 800, color: tone ? `${tone}.main` : 'text.primary' }}>{value}</Typography>
          </CardContent>
        </Card>
      </Grid>
    );
  }

  render() {
    const rows = this.props.rows || [];
    const readiness = rows.length ? Math.round(rows.reduce((a, b) => a + Number(b.readiness || 0), 0) / rows.length) : 0;
    const blocked = rows.filter((x) => x.status === 'BLOCKED').length;
    const warning = rows.filter((x) => x.status === 'WARNING').length;
    const ready = rows.filter((x) => x.status === 'READY').length;
    const missing = rows.reduce((a, b) => a + (b.missingperiods?.length || 0), 0);
    const forecastStarts = rows.map((x) => x.forecaststart).filter(Boolean);

    return (
      <Grid container spacing={2}>
        {this.renderMetric('Readiness', `${readiness}%`, readiness >= 90 ? 'success' : readiness >= 70 ? 'warning' : 'error')}
        {this.renderMetric('Ready Variables', ready, 'success')}
        {this.renderMetric('Warnings', warning, warning ? 'warning' : 'success')}
        {this.renderMetric('Blocked', blocked, blocked ? 'error' : 'success')}
        {this.renderMetric('Missing Periods', missing, missing ? 'warning' : 'success')}
        {this.renderMetric('Forecast Starts', forecastStarts[0] || '-', 'info')}
      </Grid>
    );
  }
}

export default BaselineIntegrityCards;
